var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchMyProjectsClicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "3 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32826_10522)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32826_10522",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H3V18H21V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32826_10522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.685 11.6996L15.685 11.6997L19.9337 15.9078C19.9339 15.9081 19.9342 15.9083 19.9344 15.9086C20.0292 16.0013 20.0943 16.1202 20.1209 16.2502C20.1477 16.3806 20.1345 16.5159 20.0832 16.6387C20.0319 16.7615 19.9449 16.8659 19.8338 16.9388C19.7227 17.0118 19.5925 17.0501 19.4596 17.0492M15.685 11.6996L19.4614 16.7992M15.685 11.6996C15.6226 11.6378 15.5485 11.5889 15.4672 11.5555C15.386 11.5222 15.2989 11.505 15.2111 11.505C15.1233 11.505 15.0362 11.5222 14.955 11.5555C14.9238 11.5683 14.8936 11.5834 14.8648 11.6006C16.0064 10.4301 16.6464 8.86479 16.6463 7.23362C16.6463 5.56606 15.9773 3.96731 14.7874 2.78894C13.5975 1.61066 11.9843 0.949168 10.3027 0.949219C8.62116 0.949269 7.00804 1.6108 5.81828 2.78905C4.92996 3.66717 4.32442 4.78687 4.07871 6.00653C3.83299 7.2262 3.95824 8.49063 4.43848 9.63963C4.91872 10.7886 5.73223 11.7702 6.77564 12.4606C7.8189 13.1508 9.04522 13.5188 10.2994 13.5183M15.685 11.6996L18.9875 16.8544L14.7372 12.6451C14.6747 12.5833 14.6251 12.5097 14.5911 12.4286L14.8218 12.3321L14.5911 12.4286C14.5572 12.3474 14.5397 12.2604 14.5397 12.1724C14.5397 12.0844 14.5572 11.9974 14.5911 11.9162L14.8218 12.0127L14.5911 11.9162C14.6052 11.8826 14.622 11.8503 14.6412 11.8195C14.0846 12.3389 13.4368 12.7539 12.7294 13.0439C11.959 13.3597 11.133 13.5209 10.2994 13.5183M19.4596 17.0492L19.4614 16.7992M19.4596 17.0492C19.4603 17.0492 19.4609 17.0492 19.4616 17.0492L19.4614 16.7992M19.4596 17.0492C19.3724 17.049 19.286 17.0319 19.2053 16.9988L19.3002 16.7675M19.4614 16.7992C19.4061 16.7992 19.3513 16.7885 19.3002 16.7675M19.3002 16.7675L19.2053 16.9988C19.124 16.9654 19.05 16.9164 18.9876 16.8545L18.9878 16.8546L19.3002 16.7675ZM10.2994 13.5183C10.2992 13.5183 10.2991 13.5183 10.2989 13.5183L10.2997 13.2683L10.2998 13.5183C10.2997 13.5183 10.2995 13.5183 10.2994 13.5183ZM7.52048 3.11568C8.34288 2.57148 9.31001 2.28085 10.2996 2.28082C11.6262 2.28229 12.8977 2.80489 13.835 3.73321C14.7723 4.66147 15.2991 5.91953 15.3006 7.23123C15.3005 8.20964 15.0075 9.16626 14.4584 9.98017C13.9092 10.7942 13.1283 11.429 12.2143 11.804C11.3002 12.1789 10.2942 12.2771 9.32366 12.0859C8.35313 11.8947 7.46197 11.4228 6.76274 10.7304C6.06354 10.0379 5.58766 9.15599 5.39488 8.19622C5.20212 7.23647 5.30103 6.24163 5.67922 5.33741C6.05742 4.43317 6.69806 3.6599 7.52048 3.11568Z",
    fill: "#595959",
    stroke: "#595959",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32826_10522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMyProjectsClicked);
export default __webpack_public_path__ + "static/media/searchMyProjectsClicked.3c36c8f6592932bd29e59ae4109f56c4.svg";
export { ForwardRef as ReactComponent };